import './cruise-finder.scss';

import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { createElementFromHTML, serializeForm } from '../../utilities/js/helper';
import AjaxLoad from '../../utilities/js/ajax-load';
import debounce from 'lodash.debounce';

class CruiseFinder {
    constructor (element) {
        this.$cruiseFinder = element;
        this.$results = this.$cruiseFinder.querySelector('[data-cruise-finder="results"]');
        this.$mainFilter = this.$cruiseFinder.querySelector('[data-cruise-finder="main"]');
        this.$rangeSlider = this.$cruiseFinder.querySelector('[data-cruise-finder="range-slider"]');
        this.$rangeSliderMin = this.$cruiseFinder.querySelector('[data-cruise-finder="range-min"]');
        this.$rangeSliderMax = this.$cruiseFinder.querySelector('[data-cruise-finder="range-max"]');
        this.$form = this.$cruiseFinder.querySelector('[data-cruise-finder="form"]');
        this.$rangeSliderLockedValue = this.$cruiseFinder.querySelector('[data-cruise-finder="range-locked-value"]');
        this.$filterToggle = this.$cruiseFinder.querySelector('[data-cruise-finder="filter-toggle"]');
        this.$filterCheckbox = this.$cruiseFinder.querySelector('[data-cruise-finder="filter-toggle-checkbox"]');
        this.$filterContent = this.$cruiseFinder.querySelector('[data-cruise-finder="filter-content"]');
        this.$filterContentInner = this.$cruiseFinder.querySelector('[data-cruise-finder="filter-content-inner"]');
        this.$$selectFields = this.$cruiseFinder.querySelectorAll('[data-cruise-finder="select-field"]');
        this.$$switchFields = this.$cruiseFinder.querySelectorAll('[data-cruise-finder="switch-field"]');
        this.$$allInputFields = this.$cruiseFinder.querySelectorAll('[data-cruise-finder-input="field"]');
        this.$rcpSelect = this.$cruiseFinder.querySelector('[data-cruise-finder="rcp"]');
        this.$resetAllFilter = this.$cruiseFinder.querySelector('[data-cruise-finder="reset"]');

        this.$routeGroupSelect = this.$form.querySelector('select[name="routeGroup[]"]');
        this.$countiesSelect = this.$form.querySelector('select[name="countries[]"]');
        this.$portsSelect = this.$form.querySelector('select[name="ports[]"]');
        this.$regionsSelect = this.$form.querySelector('select[name="regions[]"]');
        this.$$dateFields = this.$form.querySelectorAll('input[type="date"]');

        this.$currency = this.$cruiseFinder.querySelector('[data-cruise-finder="currency"]');
        this.$resultsCounter = this.$cruiseFinder.querySelector('[data-cruise-finder-counter]');

        this.rangeSliderMin = parseInt(this.$rangeSliderMin.dataset.rangeValue, 10);
        this.rangeSliderMax = parseInt(this.$rangeSliderMax.dataset.rangeValue, 10);
        this.rangeSliderStart = this.$rangeSliderMin.value;
        this.rangeSliderEnd = this.$rangeSliderMax.value;

        if (this.rangeSliderStart <= 0 && this.rangeSliderEnd <= 0) {
            this.rangeSliderStart = this.rangeSliderMin;
            this.rangeSliderEnd = this.rangeSliderMin;
        }

        this.ajaxURL = this.$form.getAttribute('action');
        this.ajaxActive = false;
        this.lastEmptyItemInGrid = null;
        this.$paginationSelect = this.$results.querySelector('select');
    }

    initialize () {
        this.setEvents();

        if (this.$filterToggle && this.$filterCheckbox && this.$filterContentInner) {
            this.checkSizes();
            this.activateFilterBar();

            this.$filterToggle.onclick = () => {
                this.$filterCheckbox.checked = !this.$filterCheckbox.checked;
                this.activateFilterBar();

                if (!window.mediaMatch[1024].matches) {
                    if (this.$filterCheckbox.checked) {
                        disableBodyScroll(this.$filterContentInner);
                    } else {
                        enableBodyScroll(this.$filterContentInner);
                    }
                }
            };
        }

        if (this.$rangeSlider) {
            this.initRangeSlider();
        }

        this.handleChangeOnInputField();
        this.handleResetAllFilter();
    }

    initRangeSlider () {
        const rangeSliderFlexLabel = this.$rangeSliderLockedValue.dataset.rangeLabelFlexible;
        const rangeSliderDayLabel = this.$rangeSliderLockedValue.dataset.rangeLabelDays;
        const rangeSliderFromLabel = this.$rangeSliderLockedValue.dataset.rangeLabelFrom;

        const rangeMax = this.rangeSliderMax + 1;
        let minValue;
        let maxValue;

        noUiSlider.create(this.$rangeSlider, {
            start: [this.rangeSliderStart, this.rangeSliderEnd],
            range: {
                min: this.rangeSliderMin,
                max: this.rangeSliderMax + 1
            },
            handleAttributes: [
                { 'aria-label': window.translations.filter.rangeSliderLower },
                { 'aria-label': window.translations.filter.rangeSliderUpper }
            ],
            connect: true,
            step: 1,
            tooltips: {
                to: function (value) {
                    const formatedValue = Math.round(value);
                    if (formatedValue >= rangeMax) {
                        return rangeSliderFlexLabel;
                    } else {
                        return formatedValue + ' ' + rangeSliderDayLabel;
                    }
                }
            }
        });

        const updateRangeSliderInputs = (handle, value) => {
            const formatedValue = Math.round(value);

            if (handle === 0 && this.$rangeSliderMin) {
                this.$rangeSliderMin.value = formatedValue;
                minValue = formatedValue;
            } else if (handle === 1 && this.$rangeSliderMax) {
                this.$rangeSliderMax.value = formatedValue;
                maxValue = formatedValue;

                if (formatedValue >= rangeMax) {
                    this.$rangeSliderMax.value = 365;
                }
            }

            if (minValue === maxValue && maxValue <= rangeMax) {
                this.$rangeSliderLockedValue.innerText = `${rangeSliderFromLabel} ${maxValue} ${rangeSliderDayLabel}`;
            } else if (minValue === maxValue && maxValue >= rangeMax) {
                this.$rangeSliderLockedValue.innerText = rangeSliderFlexLabel;
            } else if (maxValue >= rangeMax) {
                this.$rangeSliderLockedValue.innerText = `${rangeSliderFromLabel} ${minValue} - ${rangeSliderFlexLabel}`;
            } else {
                this.$rangeSliderLockedValue.innerText = `${minValue} - ${maxValue} ${rangeSliderDayLabel}`;
            }
        };

        this.$rangeSlider.noUiSlider.on('update', function (values) {
            values.forEach((value, index) => {
                updateRangeSliderInputs(index, value);
            });
        });

        this.$rangeSlider.noUiSlider.on('end', debounce(() => {
            this.checkBeforeSubmit(0);
        }, 1500), { passive: true });

        window.addEventListener('reset.filter', () => {
            this.$rangeSlider.noUiSlider.setHandle(0, this.rangeSliderStart, true, true);
            this.$rangeSlider.noUiSlider.setHandle(1, this.rangeSliderEnd, true, true);
        });
    }

    handleChangeOnInputField () {
        this.$$selectFields.forEach($select => {
            const $selectInput = $select.querySelector('[data-formselect]');

            if ($selectInput) {
                $selectInput.addEventListener('change', () => {
                    this.checkBeforeSubmit();
                });
            }

            window.addEventListener('reset.filter', () => {
                if ($selectInput) {
                    $selectInput.selectedIndex = -1;
                }
            });
        });

        this.$$switchFields.forEach($switch => {
            const $switchCheckbox = $switch.querySelector('[data-cruise-finder="switch-field-checkbox"]');
            const $switchToggle = $switch.querySelector('[data-cruise-finder="switch-field-toggle"]');

            $switchCheckbox.addEventListener('change', () => {
                this.checkBeforeSubmit();

                if ($switchCheckbox.name === 'isPreview' || $switchCheckbox.name === 'isAvailable') {
                    this.setActiveAvailabilitySwitch($switchCheckbox);
                }
            });

            $switchToggle.addEventListener('keydown', (event) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                    event.preventDefault();
                    $switchCheckbox.checked = !$switchCheckbox.checked;
                }
            });

            window.addEventListener('reset.filter', () => {
                if ($switchCheckbox) {
                    $switchCheckbox.checked = $switchCheckbox.getAttribute('data-toggle-switch-init-value');
                }
            });
        });
    }

    setActiveAvailabilitySwitch ($current) {
        this.$$switchFields.forEach($switch => {
            const $switchCheckbox = $switch.querySelector('[data-cruise-finder="switch-field-checkbox"]');

            if (($switchCheckbox.name === 'isPreview' || $switchCheckbox.name === 'isAvailable')) {
                if ($switchCheckbox !== $current) {
                    $switchCheckbox.checked = false;
                    $switchCheckbox.value = 0;
                } else {
                    $switchCheckbox.value = 1;
                }
            }
        });
    }

    activateFilterBar () {
        if (this.$filterCheckbox.checked) {
            this.$mainFilter.classList.add('is--active');
        } else {
            this.$mainFilter.classList.remove('is--active');
        }

        this.$filterToggle.setAttribute('aria-expanded', this.$filterCheckbox.checked);
    }

    setEvents () {
        this.$form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.checkBeforeSubmit(0);

            if (!window.mediaMatch[1024].matches) {
                this.$filterCheckbox.checked = false;
                this.activateFilterBar();
                enableBodyScroll(this.$filterContentInner);
            }
        });

        this.$currency.addEventListener('change', (e) => {
            e.preventDefault();
            this.checkBeforeSubmit(0);
        });

        if (this.$$dateFields.length > 0) {
            this.$$dateFields.forEach($dateField => {
                $dateField.onchange = () => {
                    this.checkBeforeSubmit(0);
                };
            });
        }

        window.onpopstate = (e) => {
            if (e.state === null) {
                location.replace(window.location.href);
            }
        };

        if (this.$paginationSelect && !window.mediaMatch[1024].matches) {
            this.$paginationSelect.addEventListener('change', (e) => {
                window.location.href = e.target.value;
            });
        }

        window.addEventListener('reset.filter', () => {
            if (this.$$dateFields.length > 0) {
                this.$$dateFields.forEach($dateField => {
                    $dateField.value = '';
                });
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.code === 'Tab' || event.code === 'Tabs') {
                if (!window.mediaMatch[1024].matches) {
                    this.handleOutsideTab(event);
                }
            }
        });
    }

    checkSizes () {
        if (window.mediaMatch[1024].matches) {
            this.$filterCheckbox.checked = true;
            this.activateFilterBar();
        }

        window.mediaMatch[1024].addEventListener('change', (match) => {
            if (!match.matches) {
                this.$filterCheckbox.checked = false;
                this.activateFilterBar();
            }

            if (match.matches) {
                this.$filterCheckbox.checked = true;
                this.activateFilterBar();
                enableBodyScroll(this.$filterContentInner);
            }
        });
    }

    checkMultiSelect () {
        const options = [].slice.call(this.$rcpSelect && this.$rcpSelect.options);
        const resetSelect = ($select) => {
            if ($select) {
                const $options = $select.querySelectorAll('option');

                if ($options.length > 0) {
                    $options.forEach((option) => {
                        option.selected = false;
                    });
                }
            }
        };

        resetSelect(this.$countiesSelect);
        resetSelect(this.$regionsSelect);
        resetSelect(this.$portsSelect);

        const setOption = ($select, option) => {
            const $options = Array.from($select.options);
            const optionToSelect = $options.find(item => item.text === option.text);
            optionToSelect.selected = true;
        };

        options.forEach((option) => {
            if (option.selected) {
                if (option.dataset.cruise === 'regions[]') {
                    setOption(this.$regionsSelect, option);
                }
                if (option.dataset.cruise === 'countries[]') {
                    setOption(this.$countiesSelect, option);
                }
                if (option.dataset.cruise === 'ports[]') {
                    setOption(this.$portsSelect, option);
                }
            }
        });
    }

    checkBeforeSubmit (timer = 0) {
        clearTimeout(this.waitTimer);

        if (this.ajaxActive === false) {
            this.checkMultiSelect();

            this.waitTimer = setTimeout(() => {
                this.$results.appendChild(createElementFromHTML(window.OPTIONS.loader));
                this.sendRequest();
                this.ajaxActive = true;
            }, timer);
        } else {
            console.log('Please wait.....Request is running');
        }
    }

    handleResetAllFilter () {
        const setResetEventAndSubmit = () => {
            const resetAllEvent = new CustomEvent('reset.filter', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$results
                }
            });

            window.dispatchEvent(resetAllEvent);
            this.checkBeforeSubmit(0);
        };

        this.$resetAllFilter.onclick = () => {
            setResetEventAndSubmit();
        };

        this.$resetAllFilter.addEventListener('keydown', (event) => {
            if (event.code === 'Space' || event.code === 'Enter') {
                event.preventDefault();
                setResetEventAndSubmit();
            }
        });
    }

    handleOutsideTab (e) {
        if (!this.$mainFilter.contains(e.target) && this.$filterCheckbox.checked === true) {
            this.$filterCheckbox.checked = false;
            this.activateFilterBar();
            enableBodyScroll(this.$filterContentInner);
        }
    }

    setHistory () {
        const url = this.$form.dataset.formAction + '?' + serializeForm(this.$form);

        history.pushState(null, null, url);
    }

    sendRequest () {
        const formData = new FormData(this.$form);

        formData.append('currency', this.$currency.value);
        formData.delete('rcp');

        if (this.$$switchFields.length > 0) {
            this.$$switchFields.forEach($switchField => {
                const switchField = $switchField.querySelector('[data-cruise-finder="switch-field-checkbox"]');

                if (!switchField.checked) {
                    formData.append(switchField.getAttribute('name'), '0');
                }
            });
        }

        this.setHistory();

        this.result = new AjaxLoad(this.ajaxURL, {
            requestMethod: 'post',
            requestData: formData,
            onSuccess: (resultText) => {
                const results = JSON.parse(resultText);

                if (!this.$filterCheckbox.checked && !window.mediaMatch[768].matches) {
                    enableBodyScroll(this.$filterContentInner);
                }

                this.setResult(results);
            },
            onError: (error) => {
                console.warn(error);
                this.ajaxActive = false;
                this.$results.innerHTML = `<div class="cruise-finder__no-results icon-info rte">${window.translations.cruiseFinder.error}</div>`; // this prevents the user from infinite loading screen
            }
        });
    }

    setResult (results) {
        this.ajaxActive = false;
        const $result = createElementFromHTML(results.html);
        this.$results.innerHTML = '';

        if ($result.length > 1) {
            $result.forEach((item) => {
                this.$results.appendChild(item);
            });
        } else {
            this.$results.appendChild($result);
        }

        if (results.count) {
            if (this.$resultsCounter) {
                this.$resultsCounter.firstElementChild.innerText = results.count;
            }
        } else {
            if (this.$resultsCounter) {
                this.$resultsCounter.firstElementChild.innerText = '0';
            }
        }

        const contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: this.$results
            }
        });

        window.dispatchEvent(contentUpdateEvent);

        window.bookmark.initialize(this.$results);
    }
}

export { CruiseFinder };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $cruiseFinder = $context.querySelector('[data-cruise-finder="root"]');

        if ($cruiseFinder) {
            const cruiseFinder = new CruiseFinder($cruiseFinder);
            cruiseFinder.initialize();
        }
    }
});
